<template>
    <div>{{name}}
        <AdaButton type="createButton" title="NEUE KAMPAGNE" to="/campaigns/create"></AdaButton>
        <XXLCheckbox @change="change" labelDetail="Platzierung" label="Run of Channel" initial=true></XXLCheckbox>
    </div>
</template>

<script>
    import AdaButton from "./AdaButton";
    import XXLCheckbox from "../inputs/XXLCheckbox";
    export default {
        name: "TabExample",
        components: {XXLCheckbox, AdaButton},
        props:{
            name:{
                type:String,
                required:true
            }
        },methods:{
            change:function () {
                this.$noty.success('test');
            }
        }
    }
</script>

<style scoped>

</style>